'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { BreakpointsProvider as BreakpointsProviderClient } from './BreakpointsProviderClient';
export type { breakpointsResult } from './BreakpointsProviderClient';
// Экспортируем тип и контекст из клиентского компонента для использования в хуках
export { BreakpointsContext } from './BreakpointsProviderClient';
export function BreakpointsProviderWrapper(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <BreakpointsProviderClient>{children}</BreakpointsProviderClient>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}